export enum BookmarkPages {
  HomePage = 'HomePage',
  LibraryPage = 'LibraryPage',
}
